import React, { useRef, useState } from "react";
import { Camera, X, Image as ImageIcon, Loader2 } from "lucide-react";
import { compressImageFile } from "../../lib/imageCompress";

export const PhotoUploader = ({ label, category, photos, onChange, testid }) => {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setBusy(true);
    try {
      const compressed = await Promise.all(files.map((f) => compressImageFile(f)));
      const next = [
        ...photos,
        ...compressed.map((data_url, i) => ({
          id: `${Date.now()}-${i}-${Math.random().toString(36).slice(2, 8)}`,
          category,
          data_url,
          uploaded_at: new Date().toISOString(),
        })),
      ];
      onChange(next);
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  const remove = (id) => onChange(photos.filter((p) => p.id !== id));

  return (
    <div data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <div className="font-display uppercase tracking-widest text-[11px] text-[#3f4b52] flex items-center gap-2">
          <ImageIcon size={12} /> {label} ({photos.length})
        </div>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {photos.map((p) => (
          <div key={p.id} className="relative aspect-square rounded-md overflow-hidden border border-[#cfd7db] bg-white">
            <img src={p.data_url} alt="" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => remove(p.id)}
              className="absolute top-1 right-1 h-6 w-6 rounded-full bg-black/70 text-white flex items-center justify-center"
              aria-label="Remove photo"
            >
              <X size={14} />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={busy}
          className="aspect-square rounded-md border-2 border-dashed border-[#cfd7db] bg-white flex flex-col items-center justify-center gap-1.5 text-[#3f4b52] hover:border-[#f28a16] hover:text-[#f28a16] transition"
        >
          {busy ? <Loader2 size={22} className="animate-spin" /> : <Camera size={22} />}
          <span className="text-xs font-display uppercase tracking-widest">
            {busy ? "Adding…" : "Add photo"}
          </span>
        </button>
      </div>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        capture="environment"
        multiple
        className="hidden"
        onChange={onPick}
      />
    </div>
  );
};

export default PhotoUploader;
